import { Loader2 } from "lucide-react";
import styles from "./DocumentImportOverlay.module.scss";

type DocumentImportOverlayProps = {
  isImporting: boolean;
  isDragOver: boolean;
};

export function DocumentImportOverlay({
  isImporting,
  isDragOver,
}: DocumentImportOverlayProps) {
  if (isImporting) {
    return (
      <div className={styles.processingOverlay} aria-busy="true">
        <div className={styles.shimmerPage} aria-hidden="true">
          <div className={`${styles.shimmerBlock} ${styles.shimmerTitle}`} />
          <div className={`${styles.shimmerBlock} ${styles.shimmerLine}`} />
          <div
            className={`${styles.shimmerBlock} ${styles.shimmerLine} ${styles.shimmerWide}`}
          />
          <div className={`${styles.shimmerBlock} ${styles.shimmerMedia}`} />
          <div
            className={`${styles.shimmerBlock} ${styles.shimmerLine} ${styles.shimmerMid}`}
          />
          <div className={`${styles.shimmerBlock} ${styles.shimmerLine}`} />
        </div>
        <div className={styles.processingPill}>
          <Loader2 size={15} className={styles.spinIcon} />
          Processing document…
        </div>
      </div>
    );
  }

  if (isDragOver) {
    return <div className={styles.dropHint}>Drop DOC or PDF to import</div>;
  }

  return null;
}
